import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { loadSpots } from "../features/spots/spotsSlice";
import {
  checkAuth,
  selectAuthStatus,
  setSession,
} from "../features/user/userSlice";
import Destinations from "../pages/Destination.jsx";
import HomePage from "../pages/Homepage.jsx";
import { Profile } from "../pages/Profile";
import { supabaseAuth } from "../tierApi/supabase";
import "./App.css";
import Root from "./Root.js";

const appRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Root />}>
      <Route path="/" element={<HomePage />} />
      <Route path="/destination/:slug" element={<Destinations />} />
      <Route path=":search" element={<HomePage />} />
      <Route path="/profile" element={<Profile />} />
    </Route>,
  ),
);

export default function App() {
  const dispatch = useDispatch();
  const authStatus = useSelector(selectAuthStatus);

  useEffect(() => {
    // Load first page of spots without filters on app initialization

    dispatch(loadSpots());

    if (authStatus === "idle") {
      dispatch(checkAuth());
    }
    const {
      data: { subscription },
    } = supabaseAuth.auth.onAuthStateChange((_event, session) => {
      dispatch(setSession(session));
    });

    return () => subscription.unsubscribe();
  }, [dispatch, authStatus]);

  return <RouterProvider router={appRouter} />;
}
